module.exports = __webpack_public_path__ + "static/media/2.68ffa51c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/2.png
// module id = 1125
// module chunks = 0